import Header from "../components/Header"
import Hero from "../components/Hero"
import About from "../components/About"
import Challenges from "../components/Challenges"
import HowWeWork from "../components/HowWeWork"
import Founders from "../components/Founders"
import Solutions from "../components/Solutions"
import Contact from "../components/Contact"
import Footer from "../components/Footer"
import WhatsAppFloat from "../components/WhatsAppFloat"
import Clients from "../components/Clients"

const Home = () => {
  return (
    <>
      <Header />
      <Hero />
      <About />
      <Clients />
      <Challenges />
      <HowWeWork />
      <Founders />
      <Solutions />
      <Contact />
      <Footer />
      <WhatsAppFloat />
    </>
  )
}

export default Home
